/**
 * Created by ganlu on 27/03/2017.
 */
export default () => {
    return (scope, elem) => {

        let video = elem.find('.video-player')[0];

        elem.on('click', '.play-btn', () => {
            video.play();
            $('.play-btn').css('display', 'none');
        });

        elem.on('mouseover', '.video-player', ()=>{

            if(!video.hasAttribute('controls'))
            {
                video.setAttribute('controls', 'controls');
            }
        });

        elem.on('mouseleave', '.video-player', () => {
            if(video.hasAttribute('controls'))
            {
                video.removeAttribute('controls');
            }
        });
    };
};



// WEBPACK FOOTER //
// ./src/app/components/face/index/video-control.directive.js